<template>
  <div class="userWrapEdit">
	<div class="userListEdit">
		<ul>
			<li>
				<div class="ruWrapEdit">
					<img src="./../../assets/img/images/imgT.jpg" class="L imgT">
					<div class="ruTopEdit">
						<h3>看购福利卡</h3>
						<p>6556466363388888</p>
					</div>
				</div>
				<div class="poWrapEdit">
					<div class="L"><em>100点</em><span>充值</span></div>
					<div class="R">登录此卡<i class="iconfont iconxiangyoujiantou"></i></div>
				</div>
			</li>
			<li>
				<div class="ruWrapEdit">
					<img src="./../../assets/img/images/imgT.jpg" class="L imgT">
					<div class="ruTopEdit">
						<h3>看购福利卡</h3>
						<p>6556466363388888</p>
					</div>
				</div>
				<div class="poWrapEdit">
					<div class="L"><em>100点</em><span>充值</span></div>
					<div class="R">登录此卡<i class="iconfont iconxiangyoujiantou"></i></div>
				</div>
			</li>
			<li>
				<div class="ruWrapEdit">
					<img src="./../../assets/img/images/imgT.jpg" class="L imgT">
					<div class="ruTopEdit">
						<h3>看购福利卡</h3>
						<p>6556466363388888</p>
					</div>
				</div>
				<div class="poWrapEdit">
					<div class="L"><em>100点</em><span>充值</span></div>
					<div class="R">登录此卡<i class="iconfont iconxiangyoujiantou"></i></div>
				</div>
			</li>
		</ul>
	</div>  

	<div class="loginBtnEdit">
		<span class="L otherS">绑定新卡</span>
		<span class="R">卡券清理</span>
	</div>
  </div>   

</template>

<script>
   
  	export default {
    data(){
      return {
	
      }
    },
  
   components: {
			
			
	 },

	mounted(){
	
	},
    methods:{
		}
  }
</script>

<style lang="stylus">
@import '../../assets/css/layout.styl'
@import '../../assets/css/common.styl'
@import '../../assets/css/icon.css'
.userWrapEdit 
  width 100%
  height 100%
  overflow hidden
  background #f5f5f5
  .userListEdit{
   width calc(100% - 40px)
   margin 20px auto
   li{
     width: 100%
	 height: 265px
     background: url('../../assets/img/images/bgCard.png') no-repeat center center
	 background-size: cover
	 margin: 20px 0
	 color:#fff
	 border-radius: 15px
	 .ruWrapEdit{
       width: calc(100% - 40px)
	   margin: 0 auto
	 }
	 img{
        width 60px
		height 60px  
	 }
	.poWrapEdit{
		width: calc(100% - 60px)
		margin: 70px auto 0
        span{
          border: 1px solid #ff799e
		  background: #ff799e
		  display: inline-block
		  margin-left: 10px
		  padding 0px 5px
		  border-radius 5%
		}
		
	    	
	}	
	   
     } 
   }
.L{
	float left
}
.R{
	float right
}
.ruTopEdit{
	padding-top 30px
}
.imgT{
	margin 40px 20px 0 20px
}
i{
    vertical-align middle
    font-size 18px
}

.loginBtnEdit
  width 100%
  height 90px
  line-height 90px
  background $background
  font-size 34px
  text-align center
  color:$color
  cursor pointer
  position fixed
  left:0
  right 0
  bottom 0
  margin auto
  span
   width 50%
   display inline-block
.otherS
 background #fff
 color #d3d3d3
</style>



// WEBPACK FOOTER //
// src/view/cardedit/index.vue